import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogAlertDeletePenalty = ({
    dialogShow,
    deleteAction
}) => {
    return (
        <DialogAlertAction
            width="600px"
            widthContent="80%"
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            variant="secondary"
            title="¿Deseas eliminar la sanción?"
            content="Recuerda que al eliminar la sanción, el alumno(a) podría solicitar nuevamente sus reservas.">
            <CustomButton 
                variant="secondary"
                width="120px"
                text="No, cancelar"
                onClick={() => dialogShow.set(false)}/>
            <CustomButton 
                width="120px"
                text="Sí, eliminar"
                onClick={deleteAction}/>
        </DialogAlertAction>
    );
}

export default DialogAlertDeletePenalty;